import { render } from "./SMScPrice.vue?vue&type=template&id=9a1951fa&scoped=true"
import script from "./SMScPrice.vue?vue&type=script&lang=js"
export * from "./SMScPrice.vue?vue&type=script&lang=js"

import "./SMScPrice.vue?vue&type=style&index=0&id=9a1951fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1951fa"]])

export default __exports__